import React, { ComponentProps } from "react";

export default function HyperMiniIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path d="M3.99965 0H0V3.99987H3.99965V0Z" fill="#6C53E8" />
      <path d="M3.99965 8.00098H0V12.0008H3.99965V8.00098Z" fill="#6C53E8" />
      <path
        d="M4 4.00024V8.00012H7.99965V12.0012H11.9993V8.00012V4.00024H7.99965H4Z"
        fill="#6C53E8"
      />
    </svg>
  );
}
